// App colour themes. The whole UI is tinted through the --color-primary*
// variables declared in index.css; a theme just swaps those values at runtime.
// The selection persists in app settings under the `theme_color` key.

export interface ThemePreset {
  id: string;
  label: string;
  primary: string;
  primaryDark: string;
  primaryDarker: string;
  primaryLight: string;
}

export const THEME_PRESETS: ThemePreset[] = [
  { id: 'teal', label: 'Teal (Default)', primary: '#00aa8d', primaryDark: '#008975', primaryDarker: '#025548', primaryLight: '#00bf9a' },
  { id: 'blue', label: 'Blue', primary: '#1976d2', primaryDark: '#1565c0', primaryDarker: '#0d3c78', primaryLight: '#2196f3' },
  { id: 'navy', label: 'Navy', primary: '#3949ab', primaryDark: '#283593', primaryDarker: '#161f66', primaryLight: '#5c6bc0' },
  { id: 'green', label: 'Green', primary: '#2e7d32', primaryDark: '#1b5e20', primaryDarker: '#0f3d13', primaryLight: '#43a047' },
  { id: 'orange', label: 'Orange', primary: '#ef6c00', primaryDark: '#e65100', primaryDarker: '#933700', primaryLight: '#fb8c00' },
  { id: 'purple', label: 'Purple', primary: '#7b1fa2', primaryDark: '#6a1b9a', primaryDarker: '#471168', primaryLight: '#9c27b0' },
  { id: 'maroon', label: 'Maroon', primary: '#c62828', primaryDark: '#b71c1c', primaryDarker: '#7f1212', primaryLight: '#e53935' },
  { id: 'pink', label: 'Pink', primary: '#c2185b', primaryDark: '#ad1457', primaryDarker: '#760d3a', primaryLight: '#e91e63' },
];

export const DEFAULT_THEME_ID = 'teal';

export function getThemePreset(id: string): ThemePreset {
  return THEME_PRESETS.find((t) => t.id === id) ?? THEME_PRESETS[0];
}

// Overwrite the :root colour variables with the chosen preset.
export function applyTheme(id: string): void {
  const theme = getThemePreset(id);
  const root = document.documentElement.style;
  root.setProperty('--color-primary', theme.primary);
  root.setProperty('--color-primary-dark', theme.primaryDark);
  root.setProperty('--color-primary-darker', theme.primaryDarker);
  root.setProperty('--color-primary-light', theme.primaryLight);
}
